<div class="pane">
  <p-progressSpinner *ngIf="loading" styleClass="custom-spinner" strokeWidth="4"></p-progressSpinner>

  <!-- Header Links -->
  <div class="pre-header">
    <span>Go to:</span>
    <a [routerLink]="['/dashboard', 'order-history']" class="ml-2">Order History</a>
    <span class="ml-4 text-primary cursor-pointer" (click)="downloadPayables()">
      <i class="pi pi-file-pdf mr-1"></i>
      <a href="#" (click)="$event.preventDefault(); downloadPayables();" class="text-primary"
         pTooltip="Download a PDF of all billings" tooltipPosition="top">
        All Billings (PDF)
      </a>
    </span>
  </div>

  <!-- Tab Buttons -->
  <div class="tab-button-group">
    <button *ngIf="canAccessPermission(Permissions.FinancialData)"
            pButton size="small" icon="pi pi-folder-open" label="Open"
            [class.p-button-outlined]="openTab !== 'MSS'"
            [class.p-button-info]="openTab === 'MSS'"
            (click)="setTab('MSS')">
    </button>

    <button *ngIf="canAccessPermission(Permissions.FinancialData)"
            pButton size="small" icon="pi pi-check-circle" label="Paid"
            [class.p-button-outlined]="openTab !== 'MSH'"
            [class.p-button-info]="openTab === 'MSH'"
            (click)="setTab('MSH')">
    </button>

    <button *ngIf="canAccessPermission(Permissions.OrderHistory)"
            pButton size="small" icon="pi pi-clock" label="Backorders"
            [class.p-button-outlined]="openTab !== 'BOS'"
            [class.p-button-info]="openTab === 'BOS'"
            (click)="setTab('BOS')">
    </button>

    <button *ngIf="canAccessPermission(Permissions.OrderHistory)"
            pButton size="small" icon="pi pi-send" label="Shipped"
            [class.p-button-outlined]="openTab !== 'OSS'"
            [class.p-button-info]="openTab === 'OSS'"
            (click)="setTab('OSS')">
    </button>
  </div>

  <!-- Data Table -->
  <div class="card shadow-2 border-round p-3 surface-card tab-content">
    <p-table *ngIf="tableInfo?.columns"
             #dt
             [value]="visibleData[openTab]"
             [columns]="tableInfo?.columns"
             [scrollable]="true"
             scrollHeight="600px"
             scrollDirection="both"
             [frozenColumns]="[{ field: 'po', header: 'PO' }]"
             [frozenValue]="frozenRows"
             [paginator]="true"
             [totalRecords]="totalRecords[openTab]"
             [rows]="50"
             [globalFilterFields]="globalFilterFields"
             [sortMode]="'multiple'"
             [resizableColumns]="false"
             [virtualScroll]="false"
             [showFooter]="true"
             [lazy]="true"
             (onLazyLoad)="onLazyLoad($event)"
             class="p-datatable-gridlines p-datatable-sm p-datatable-striped sticky-header">

      <!-- Caption -->
      <ng-template pTemplate="caption">

        <div class="p-datatable-caption column-layout">
          <div class="button-group-center">
            <button pButton size="small" label="Clear" icon="pi pi-filter-slash" class="p-button-outlined"
                    (click)="clearFilters(dt)"></button>
            <button pButton size="small" label="Export Current" icon="pi pi-file-excel" class="p-button-outlined"
                    (click)="onExportTab(openTab)"></button>
            <button pButton size="small" label="Export All" icon="pi pi-cloud-download" class="p-button-outlined"
                    (click)="exportAllTabsToExcel()"></button>
          </div>

          <span class="p-input-icon-left search-container">
            <i class="pi pi-search"></i>
            <input pInputText type="text" #globalFilter (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search..." />
          </span>
        </div>
      </ng-template>

      <!-- Header -->
      <ng-template pTemplate="header" let-columns>
        <tr>

          <th *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              [sortable]="col.sort"
              [style.width.px]="col.field === 'tracking' ? 160 : null">

            <div class="flex justify-content-between align-items-center">
              {{ col.title }}
              <p-sortIcon *ngIf="col.sort" [field]="col.field"></p-sortIcon>
            </div>
            <p-columnFilter *ngIf="col.filterType"
                            [type]="col.filterType"
                            [field]="col.field"
                            display="menu"
                            [placeholder]="col.placeholder || 'Search'">
            </p-columnFilter>
          </th>
        </tr>
      </ng-template>

      <!-- Body -->
      <ng-template pTemplate="body" let-row let-columns="columns">
        <tr>
          <td *ngFor="let col of columns" [ngClass]="{ 'wrap-tracking': col.field === 'trackingLinks' }">
            <ng-container [ngSwitch]="col.type || col.field">

              <!-- Tracking -->
              <ng-container *ngSwitchCase="'trackingLinks'">
                <span [innerHTML]="sanitizeHtml(row[col.field])"></span>
              </ng-container>


              <!-- Date -->
              <span *ngSwitchCase="'date'">
                {{ row[col.field] | date: col.format || 'MM/dd/yyyy' }}
              </span>

              <!-- Currency -->
              <span *ngSwitchCase="'currency'">
                {{ row[col.field] | currency }}
              </span>

              <!-- Action Column -->
              <ng-container *ngSwitchCase="'action'">
                <a *ngIf="col.field === 'invoice'"
                   href="#"
                   (click)="col.callback(row, this); $event.preventDefault();"
                   class="text-primary">
                  <i class="pi pi-download mr-1"></i>{{ row[col.field] || 'Download' }}
                </a>

                <a *ngIf="col.field !== 'invoice'"
                   href="#"
                   (click)="col.callback(row, this); $event.preventDefault();">
                  {{ row[col.field] }}
                </a>
              </ng-container>

              <!-- Default -->
              <ng-container *ngSwitchDefault>
                {{ row[col.field] }}
              </ng-container>



            </ng-container>
          </td>
        </tr>
      </ng-template>



      <!-- Totals Footer -->
      <ng-template pTemplate="footer" let-columns>
        <tr>
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">

              <!-- Total for Amount -->
              <span *ngSwitchCase="'gross'">
                <strong>Total:</strong> {{ getTotal('gross') | currency }}
              </span>

              <!-- Total for Amount -->
              <span *ngSwitchCase="'discount'">
                <strong>Total:</strong> {{ getTotal('discount') | currency }}
              </span>


              <!-- Total for Amount -->
              <span *ngSwitchCase="'net'">
                <strong>Total:</strong> {{ getTotal('net') | currency }}
              </span>


          
              <!-- Empty default -->
              <span *ngSwitchDefault></span>

            </ng-container>
          </td>
        </tr>
      </ng-template>



      <!-- Empty State -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="tableInfo?.columns?.length">No data available.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
